<template>
  <div class="hotel_container">
    <div class="hotel_list_box container" v-if="!detailFlag">
      <b-container>
        <b-row>
          
          <b-col md="6" lg="4" v-for="(v, i) in hotelList" :key="i" @click="checkDetail(i)">
            <div class="hotel_list_box_item mt-40" v-if="i < 9">
              <div class="img_mask">
                <div>
                  <i class="el-icon-search"></i>
                </div> 
                <img :src="v.coverImg" class="item_img" height="230px" :alt="v.alt" />
              </div>
              <div class="mt-20 color-fff fs-20">{{ v.title }}</div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <!-- <el-pagination background layout="prev, pager, next" :total="10"></el-pagination> -->
    </div>
    <div class="detail_wrap container" v-if="detailFlag">
      <div v-html="hotelList[curIndex].desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailFlag: false,
      curIndex: undefined,
      showHotel: false,
      noneHotelList:[],
      hotelList: [
        {
          title: "广交会威斯汀酒店",
          coverImg:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/main.jpg",
          desc: `<h2 class='media_line_height_50 media_font_size_50'>广交会威斯汀酒店</h2>
<span class="detail_date">发布时间：2023-10-18</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/logo.jpg' style="width:220px;"  alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>联系人：廖嘉奇</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>电话：020-89181604</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>传真：020-89181699</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>手机：13824448184</span>
<img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/fee.jpg' alt/>
<div class="detail_show">
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/1.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/2.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/3.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/4.jpg' alt/>
</div>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/1/traffic.jpg' alt/>
`
        },
        {
          title: "广州四季酒店",
          coverImg:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/main.jpg",
          desc: `<h2 class='media_line_height_50 media_font_size_50'>广州四季酒店</h2>
<span class="detail_date">发布时间：2023-10-18</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/logo.jpg' style="width:220px;"  alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>联系人：莫斯婷</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>电话：020-88833206</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>传真：020-88833990</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>手机：13825009212</span>
<img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/fee.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>广州四季酒店地处珠江新城新地标国际金融中心，视野极佳，透过客房外的幕墙玻璃，可将珠江及日新月异的城市景观尽收眼底。酒店拥有各类客房，分布于74至98层之间，平均客房面积超过70平方米。客房设计时尚，豪华舒适，在世界各地及本土名家的艺术精品点缀下，处处彰显高雅品味。每个房间均配备先进的高科技设施，包括高速宽带上网、语音留言系统、等离子大屏幕电视；特别定制的睡床让每位宾客酣然入梦，宽敞的大理石浴室内有超大浴缸和独立淋浴间，并设有嵌入式镜面电视。酒店共有6间风格各异的餐厅及酒吧，为宾客带来环球特色美食。来自世界各地的国际星级名厨，以其精湛的厨艺，崭新的饮食理念，贴心的专业服务为您呈献殿堂级的餐饮美食，把“吃在广州”的美誉升华至最高境界。</span>
<div class="detail_show">
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/1.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/2.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/3.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/2/4.jpg' alt/>
</div>`
        },
//         {
//           title: "奥园喜来登",
//           coverImg:
//             "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/main.jpg",
//           desc: `<h2 class='media_line_height_50 media_font_size_50'>奥园喜来登</h2>
// <span class="detail_date">发布时间：2016-10-18</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>联系人：何乐思</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>电话：020-39308083</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>传真：020-32668889</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>手机：13826488870</span>
// <img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/fee.png' alt/>
// <span class='detail_desc media_line_height_50 media_font_size_50'>广州奥园喜来登酒店地处番禺商务中心区的核心地段，毗邻国家级主题乐园广州长隆度假区以及多家高端购物中心。步行5分钟即达地铁7号线南村万博站，从酒店驱车20分钟即可抵达广州南站，宾客可由此便捷抵达广州各个区域及全国各地。以璀璨珠宝为灵感设计，广州奥园喜来登酒店设有274间客房及套房、3间各具特色的餐厅及酒吧、1375平方米的宴会空间，打造适合商务及休闲出行的特色空间，热情欢迎本地及全球客人在此会聚与交流。</span>
// <div class="detail_show">
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/1.jpg' alt/>
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/2.jpg' alt/>
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/3.jpg' alt/>
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/4.jpg' alt/>
// </div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/3/traffic.jpg' alt/>`
//         },
        {
          title: "广州东圃喜来登酒店",
          coverImg:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/cover.jpg",
          desc: `<h2 class='media_line_height_50 media_font_size_50'>广州东圃喜来登酒店</h2>
<span class="detail_date">发布时间：2023-10-18</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/logo.png' style="width:220px;"  alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>联系人：谭小姐</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>电话：020–32110888</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>手机：18933971477</span>
<img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/fee.png' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>广州东圃合景福朋喜来登酒店位于天河东圃繁华中心地带，交通便捷，可快速到达金融城及众多大型交易展览所在地的琶洲会展中心 。 酒店共有296 间简约典雅的客房与套间，可俯瞰广州城景 。在这里，我们为您准备好福朋特色舒适之床、高速网络连接及精致的浴室配套设施等，为您营造安心休憩之所。</span>
<div class="detail_show">
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/1.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/2.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/3.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/4.jpg' alt/>
</div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/10/traffic.png' alt/>`
        },
        {
          title: "广州阳光酒店",
          coverImg:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/main.jpg",
          desc: `<h2 class='media_line_height_50 media_font_size_50'>广州阳光酒店</h2>
<span class="detail_date">发布时间：2023-10-18</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/logo.jpg' style="width:220px;"  alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>地址：广州市天河区黄埔大道中 199号</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>联系人：吕晶</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>电话：020-38018888</span>
<img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/fee.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>广州阳光酒店43层主体建筑地处广州市天河区黄埔大道商业圈中心，远眺珠江新城及广州塔，毗邻红砖厂创意产业园，与琶洲国际会展中心仅一桥之隔，5分钟车程即可抵达。10分钟车程即可到达购物商城，城市影院，火车地铁枢纽，文化中心，交通优越，出行便捷。身处广州未来金融CBD核心区域，酒店被天河区政府、科技软件园及创意产业园围绕。通过华南干线、京珠高速公路构建而成的快速交通网，45分钟内可到达白云国际机场，当日往返深圳、珠海。您也可以使用临近酒店的2个地铁口，通过这种绿色高效的交通工具探索发现当代广州，古老南粤。</span>
<div class="detail_show">
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/1.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/2.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/3.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/4.jpg' alt/>
</div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/5/traffic.jpg' alt/>`
        },
        {
          title: "广州维多利酒店",
          coverImg:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/cover.jpg",
          desc: `<h2 class='media_line_height_50 media_font_size_50'>广州维多利酒店</h2>
<span class="detail_date">发布时间：2023-10-18</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/logo.png' style="width:220px;"  alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>地址：广州市天河区黄埔大道西106号广州维多利酒店</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>联系人：池先生</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>手机：18022329217</span>
<img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/fee.png' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>广州维多利酒店坐落于天河区珠江新城 CBD 内繁华的商业中心地区，交通便利，毗邻琶洲会展中心,。酒店是一家按国际高星级标准兴建，集商务、会议、住宿、餐饮、康体及娱乐于一体多功能智能化的商务酒店。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>酒店共设有253间高雅精致的客房，能为繁忙的宾客提供宽敞舒适的环境和体贴入微的服务。酒店内设有大、中、小型多功能会议厅及中餐厅。配套健身房、洗衣房免费提供使用，以及免费停车场、WIFI上网。</span>
<div class="detail_show">
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/1.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/2.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/3.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/11/4.jpg' alt/>
</div>`
        },
//         {
//           title: "生物岛高新木莲庄酒店",
//           coverImg:
//             "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/7/main.jpg",
//           desc: `<h2 class='media_line_height_50 media_font_size_50'>生物岛高新木莲庄酒店</h2>
// <span class="detail_date">发布时间：2016-10-18</span>
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/7/logo.jpg' style="width:220px;"  alt/>
// <span class='detail_desc media_line_height_50 media_font_size_50'>地址：广州市海珠区国际生物岛星岛环南路106号B3栋</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>联系人：王斯</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>电话:020-8092 3888</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>传真:020-3195 0509</span>
// <img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/7/fee.jpg' alt/>
// <span class='detail_desc media_line_height_50 media_font_size_50'>酒店位于广州国际生物岛，地处琶洲国际会展中心核心区，地理位置得天独厚，周边环境优美，百米内汇聚众多生物科技研究中心与生命科学产业园，南依广州大学城，北邻琶洲国际会展中心，交通便利。</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>酒店距地铁官洲站约800米，可免费乘坐观光车往返地铁站跟酒店之间；距琶洲国际会展中心直线距离约4公里，地铁2站即可到达。</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>酒店拥有322间客房，拥有2个超过200平米以上宴会厅及会议室，配备先进的影音视听设备和高速网络接口，尽享繁忙都市中的舒适与宁静，是商务、休闲度假之理想选择。</span>
// <div class="detail_show">
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/7/1.jpg' alt/>
// </div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/7/traffic.jpg' alt/>`
//         },
        {
          title: "江韵大酒店",
          coverImg:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/main.jpg",
          desc: `<h2 class='media_line_height_50 media_font_size_50'>江韵大酒店</h2>
<span class="detail_date">发布时间：2023-10-18</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/logo.jpg' style="width:220px;"  alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>地址:广州市天河区棠安路121号</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>联系人：王建勋</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>电话：020-85556188 </span>
<span class='detail_desc media_line_height_50 media_font_size_50'>传真：020-85557322</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>手机：13533049196</span>
<img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/fee.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>广州江韵大酒店是一家集客房、餐饮、会议、娱乐于一体的四星级商务酒店，位于科韵北路与广园快速路交汇处，紧靠中山大道西与琶洲桥，酒店距离琶洲国际会展中心仅5分钟车程。</span>
<div class="detail_show">
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/1.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/2.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/3.jpg' alt/>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/4.jpg' alt/>
</div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/8/traffic.jpg' alt/>`
        },
//         {
//           title: "铂顿国际公寓",
//           coverImg:
//             "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/9/main.jpg",
//           desc: `<h2 class='media_line_height_50 media_font_size_50'>铂顿国际公寓</h2>
// <span class="detail_date">发布时间：2016-10-18</span>
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/9/logo.jpg' style="width:220px;"  alt/>
// <span class='detail_desc media_line_height_50 media_font_size_50'>地址：广州市海珠区新港东路43号</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>联系人：时阳</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>电话：020-89572600</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>传真：020-89572570</span>
// <span class='detail_desc media_line_height_50 media_font_size_50'>手机：18026299605</span>
// <img class="detail_fee" src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/9/fee.jpg' alt/>
// <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/hotel/9/traffic.jpg' alt/>`
//         }
      ]
    };
  },
  mounted() {
    // this.showHotel = localStorage.getItem("showHotel");
    // console.log(this.showHotel);
  },
  methods: {
    checkDetail(i) {
      this.curIndex=i
      this.detailFlag=true
    },
    showList(){
      this.detailFlag=false
    }
  }
};
</script>

<style lang="scss">
.hotel_container {
  color: #fff;
  display: flex;
  width: 100%;
  .hotel_list_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    .hotel_list_box_item {
      .img_mask {
        position: relative;
        > div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          > i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }
      .img_mask:hover {
        > div {
          visibility: visible;
        }
      }
    }
  }
    .detail_wrap {
    margin-bottom: 100px;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      > h2 {
        text-align: center;
        color: #fff;
        font-size: 30px;
      }
      .detail_title {
        color: #42abff;
        font-size: 20px;
        margin-bottom: 53px;
      }
      .detail_date {
        text-align: center;
        color: #ccc;
        margin-bottom: 56px;
        font-size: 20px;
        margin: 20px;
        margin-bottom: 100px;
      }
      .detail_desc {
        font-size: 24px;
        color: #ccc;
        text-indent: 50px;
      }
      .detail_fee{
        width: 900px;
        margin:50px;
      }
      .detail_show{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        >img{
          width: 48%;
          margin:50px 0px;
          height: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// hotel.vue?2b551efe